export default "__VITE_ASSET__3VCm34PW__"